import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type PageWrapperProps = ComponentProps<"div">

function PageWrapper(props: PageWrapperProps) {
  const { className, ...divProps } = props
  return <div className={cn("page-wrapper", className)} {...divProps} />
}

export default PageWrapper
